import Dialog from './dialog.vue';
import inModal from './in-modal.vue';
import inTree from './in-tree.vue';

const modal = {
    Dialog,inModal,inTree
}

export default modal;


// WEBPACK FOOTER //
// ./src/components/inc/modal/index.js